import { useState, useEffect } from "react";
import { getSettledBets } from "../../../AsianExchangeSrc/api";
import Loader from "../../../AsianExchangeSrc/utils/Loader";
import CommonTable from "../../components/TableComponent/TableComponent";

const BetHistory = () => {
  const [dataSource, setDataSource] = useState("");
  const [sport, setSport] = useState("Cricket");
  const today = new Date();
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(today.getDate() - 3);
  const formatDate = (date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formatDate(threeDaysAgo));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [betHistory, setBetHistory] = useState([]);

  useEffect(() => {
    const today = new Date();
    const formatDate = (date) => date.toISOString().split("T")[0];

    if (dataSource === "Live Data") {
      setStartDate(formatDate(today));
      setEndDate(formatDate(today));
    } else if (dataSource === "Backup Data") {
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(today.getMonth() - 3);
      setStartDate(formatDate(threeMonthsAgo));
      setEndDate(formatDate(today));
    } else if (dataSource === "Old Data") {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(today.getFullYear() - 1);
      setStartDate(formatDate(oneYearAgo));
      setEndDate(formatDate(today));
    }
  }, [dataSource]);

  const fetchSettledBets = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = { sportId: sport, startDate, endDate };
      const res = await getSettledBets(params);
      if (res.success) {
        setBetHistory(
          res?.data?.data.map((bet, index) => ({
            id: bet._id || index, // Ensure unique ID
            sportsName: bet.sportsName || "-",
            event: bet.event || "-",
            market: bet.market || "-",
            selection: bet.selection || "-",
            type: bet.type || "-",
            oddsReq: bet.oddsReq || "-",
            stake: bet.stake || "-",
            createdAt: bet.createdAt || "-",
          }))
        );
      } else {
        setError("No Bets Found For " + sport || "Failed to fetch bet history");
      }
    } catch (error) {
      setError(error.message || "An error occurred while fetching bet history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettledBets();
  }, [sport, startDate, endDate]);

  const handleGetHistory = () => {
    fetchSettledBets();
  };

  const columns = [
    { key: "sportsName", header: "Sport Name", mobileLabel: "Sport" },
    { key: "event", header: "Event Name", mobileLabel: "Event" },
    { key: "market", header: "Market Name", mobileLabel: "Market" },
    { key: "selection", header: "Selection", mobileLabel: "Selection" },
    { key: "type", header: "Type", mobileLabel: "Type" },
    { key: "oddsReq", header: "Odds Req.", mobileLabel: "Odds" },
    { key: "stake", header: "Stack", mobileLabel: "Stack" },
    { key: "createdAt", header: "Matched Time", mobileLabel: "Time" },
  ];

  return (
    <div className="mx-auto bg-light-bg dark:bg-dark-bg border-t-2 rounded-t-lg border-gray-900 mx-1">
      {/* Filter Section */}
      <div className="bg-light-bg dark:bg-dark-bg p-4 space-y-4 border-2 border-gray-300">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <select
              value={dataSource}
              onChange={(e) => setDataSource(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white"
            >
              <option value="">All Sources</option>
              <option value="Live Data">Live Data</option>
              <option value="Backup Data">Backup Data</option>
              <option value="Old Data">Old Data</option>
            </select>
          </div>
          <div>
            <select
              value={sport}
              onChange={(e) => setSport(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white"
            >
              <option value="">All Sports</option>
              <option value="Cricket">Cricket</option>
              <option value="Soccer">Soccer</option>
              <option value="Tennis">Tennis</option>
              <option value="Horse Race">Horse Race</option>
              <option value="Greyhound Race">Greyhound Race</option>
            </select>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="relative">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white pr-10"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>
          <div className="relative">
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white pr-10"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <button
            onClick={handleGetHistory}
            disabled={loading}
            className={`w-full bg-[#6A7D88] text-white font-medium py-2 px-4 rounded transition-colors ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:bg-slate-700"
            }`}
          >
            {loading ? "Loading..." : "Get History"}
          </button>
        </div>
        {error && (
          <div className="text-red-500 text-base text-center">{error}</div>
        )}
      </div>

      {/* Bet History Table */}
      {!loading && !error && (
        <CommonTable
          title="Bet History"
          data={betHistory}
          columns={columns}
          showEntriesOptions={[10, 25, 50, 100]}
          initialEntriesPerPage={10}
          showPagination={true}
          emptyMessage="No bet history found"
        />
      )}
      {loading && <Loader />}
    </div>
  );
};

export default BetHistory;